import React, { FC, useEffect, useState } from 'react';

import { useSelector } from 'react-redux';
import { customTheme } from 'theme';

import { selectActiveResource } from 'containers/ActiveCloudResource/selectors';

import { Breakdown } from './Breakdown';

export const DistributionByTypesOfFiles: FC = () => {
  const { data } = useSelector(selectActiveResource);
  const { data: labels, isLoading } = data.typesOfFiles;
  const [chartData, setChartData] = useState<Record<string, any>[]>([]);

  useEffect(() => {
    setChartData(
      [
        {
          name: 'Table format',
          value: labels?.table_format,
          percent: labels?.table_format_percentage,
        },
        {
          name: 'Documents',
          value: labels?.documents,
          percent: labels?.documents_percentage,
        },
        {
          name: 'Images',
          value: labels?.images,
          percent: labels?.images_percentage,
        },
        {
          name: 'Archive',
          value: labels?.archives,
          percent: labels?.archives_percentage,
        },
        {
          name: 'Other',
          value: labels?.other,
          percent: labels?.other_percentage,
        },
      ].filter(o => !!o.value),
    );
  }, [labels]);

  const colorMap = {
    'Table format': customTheme.colors.blue['300'],
    Documents: customTheme.colors.skyBlue['300'],
    Images: customTheme.colors.primary,
    Archive: customTheme.colors.green['300'],
    Other: customTheme.colors.orange['300'],
  };

  return (
    <Breakdown
      data={chartData}
      isLoading={isLoading}
      label="Distribution by types of files"
      colorMap={colorMap}
    />
  );
};
